export { FBTDrawerContent } from './fbt-content';
